import type { IconData } from '@stacksjs/iconify-core'

export const halfStar2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3v36.879l-9.672 4.797c-2.244 1.113-4.784-.798-4.466-3.36l1.381-11.122l-7.388-8.165c-1.698-1.877-.73-4.962 1.706-5.44l10.555-2.064l5.124-9.818C21.834 3.569 22.917 3 24 3\"/><path stroke-dasharray=\"4 6\" d=\"M24 3c2.402 0 4.225 3.113 5.617 6.22c1.49 3.328 4.385 5.478 7.997 5.986c3.332.47 6.74 1.382 7.3 3.844c.543 2.383-2.099 5.051-4.728 7.325c-2.64 2.282-3.675 5.577-2.834 8.964c.895 3.602 1.56 7.629-.595 9.114c-1.658 1.142-4.25.262-6.757-1.05c-2.357-1.234-4.64-2.85-6-3.524\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default halfStar2
